<!-- eslint-disable max-len -->
<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Receiving of Abalone</h1>
        <v-row>
          <v-col cols="4">
            <v-select
              data-cy="FormReceivingOfCultivatedAbolone-farmId"
              filled
              :label="$$t('farm')"
              :items="farms"
              item-text="name"
              item-value="id"
              v-model="localReceivingOfCultivatedAbolone.farm"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <DateField
              filled
              data-cy="FormReceivingOfCultivatedAbolone-dateReceived"
              :label="$$t('dateReceived')"
              v-model="localReceivingOfCultivatedAbolone.dateReceived"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              label="Size range"
              v-model="localReceivingOfCultivatedAbolone.sizeRange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.closedVehicle"
              :label="$$t('closedVehicle')"
            />
          </v-col>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.openContainers"
              :label="$$t('openContainers')"
            />
          </v-col>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.inBags"
              :label="$$t('inBags')"
            />
          </v-col>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.vehicleClean"
              :label="$$t('vehicleClean')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-totalMassReceived"
              :label="$$t('totalMassReceived')"
              v-model="localReceivingOfCultivatedAbolone.totalMassReceived"
              hint="Total mass applied"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-arrivalTemperature"
              :label="$$t('arrivalTemperature')"
              v-model="localReceivingOfCultivatedAbolone.arrivalTemperature"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-vehicleTemperature"
              :label="$$t('vehicleTemperature')"
              v-model="localReceivingOfCultivatedAbolone.vehicleTemperature"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.identificationCompleted"
              :label="$$t('identificationCompleted')"
            />
          </v-col>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.gapCertified"
              :label="$$t('gapCertified')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.damangedCuts"
              filled
              data-cy="FormReceivingOfCultivatedAbolone-damangedCuts"
              :label="$$t('damangedCuts')"
              @input="damagedCutsChanged"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model.number="localReceivingOfCultivatedAbolone.damangedCutsWeight"
              filled
              :disabled="!localReceivingOfCultivatedAbolone.damangedCuts"
              data-cy="FormReceivingOfCultivatedAbolone-damangedCuts"
              type="number"
              :label="$$t('weight')"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.damangedCuts"
              data-cy="FormReceivingOfCultivatedAbolone-damangedCuts"
              v-model.number="localReceivingOfCultivatedAbolone.damangedCutsNumber"
              type="number"
              :label="$$t('number')"
            />
          </v-col>
          <v-col cols="3">
            <ColouredValueBool
              v-show="localReceivingOfCultivatedAbolone.damangedCuts"
              :value="localReceivingOfCultivatedAbolone.damangedCutsWeight > 0
                && localReceivingOfCultivatedAbolone.damangedCutsNumber > 0"
              text="Required to complete"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.damagedLesion"
              :label="$$t('damagedLesion')"
              @input="damagedLesionChanged"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.damagedLesion"
              data-cy="FormReceivingOfCultivatedAbolone-damagedLesion"
              v-model.number="localReceivingOfCultivatedAbolone.damagedLesionWeight"
              type="number"
              :label="$$t('weight')"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.damagedLesion"
              data-cy="FormReceivingOfCultivatedAbolone-damagedLesion"
              v-model.number="localReceivingOfCultivatedAbolone.damagedLesionNumber"
              type="number"
              :label="$$t('number')"
            />
          </v-col>
          <v-col cols="3">
            <ColouredValueBool
              v-show="localReceivingOfCultivatedAbolone.damagedLesion"
              :value="localReceivingOfCultivatedAbolone.damagedLesionWeight > 0
                && localReceivingOfCultivatedAbolone.damagedLesionNumber > 0"
              text="Required to complete"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.visibleParasites"
              :label="$$t('visibleParasites')"
              @input="visibleParasitesChanged"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.visibleParasites"
              data-cy="FormReceivingOfCultivatedAbolone-visibleParasites"
              v-model.number="localReceivingOfCultivatedAbolone.visibleParasitesWeight"
              type="number"
              :label="$$t('weight')"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.visibleParasites"
              data-cy="FormReceivingOfCultivatedAbolone-visibleParasites"
              v-model.number="localReceivingOfCultivatedAbolone.visibleParasitesNumber"
              type="number"
              :label="$$t('number')"
            />
          </v-col>
          <v-col cols="3">
            <ColouredValueBool
              v-show="localReceivingOfCultivatedAbolone.visibleParasites"
              :value="localReceivingOfCultivatedAbolone.visibleParasitesWeight > 0
                && localReceivingOfCultivatedAbolone.visibleParasitesNumber > 0"
              text="Required to complete"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <BoolField
              filled
              data-cy="FormReceivingOfCultivatedAbolone-deadLameAnimals"
              :label="$$t('deadLameAnimals')"
              v-model="localReceivingOfCultivatedAbolone.deadLameAnimals"
              @input="deadLameAnimalsChanged"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.deadLameAnimals"
              data-cy="FormReceivingOfCultivatedAbolone-mortalitiesWeight"
              v-model.number="localReceivingOfCultivatedAbolone.mortalitiesWeight"
              type="number"
              :label="$$t('weight')"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              filled
              :disabled="!localReceivingOfCultivatedAbolone.deadLameAnimals"
              data-cy="FormReceivingOfCultivatedAbolone-mortalitiesCount"
              :label="$$t('mortalitiesCount')"
              v-model.number="localReceivingOfCultivatedAbolone.mortalitiesCount"
            />
          </v-col>
          <v-col cols="3">
            <ColouredValueBool
              v-show="localReceivingOfCultivatedAbolone.deadLameAnimals"
              :value="localReceivingOfCultivatedAbolone.mortalitiesCount > 0
                && localReceivingOfCultivatedAbolone.mortalitiesWeight > 0"
              text="Required to complete"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-suspectedCauseOfMortality"
              :label="$$t('suspectedCauseOfMortality')"
              v-model="localReceivingOfCultivatedAbolone.suspectedCauseOfMortality"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <BoolField
              filled
              data-cy="FormReceivingOfCultivatedAbolone-areAnimalsClean"
              :label="$$t('areAnimalsClean')"
              v-model="localReceivingOfCultivatedAbolone.areAnimalsClean"
            />
            <v-text-field
              v-if="!localReceivingOfCultivatedAbolone.areAnimalsClean"
              v-model="localReceivingOfCultivatedAbolone.areAnimalsCleanReason"
              label="Reason animals are not clean"
              filled
            />
          </v-col>
          <v-col cols="4">
            <BoolField
              filled
              data-cy="FormReceivingOfCultivatedAbolone-chemicalsDetected"
              :label="$$t('chemicalsDetected')"
              v-model="localReceivingOfCultivatedAbolone.chemicalsDetected"
            />
            <v-text-field
              v-if="!localReceivingOfCultivatedAbolone.chemicalsDetected"
              v-model="localReceivingOfCultivatedAbolone.chemicalsDetectedReason"
              label="Reason for chemicals detected"
              filled
            />
          </v-col>
          <v-col cols="4">
            <BoolField
              filled
              data-cy="FormReceivingOfCultivatedAbolone-animalsForProduction"
              :label="$$t('animalsForProduction')"
              v-model="localReceivingOfCultivatedAbolone.animalsForProduction"
            />
            <v-text-field
              v-if="!localReceivingOfCultivatedAbolone.animalsForProduction"
              v-model="localReceivingOfCultivatedAbolone.animalsForProductionReason"
              label="Reason for animals not suitable"
              filled
            />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12">
            <v-textarea
              filled
              data-cy="FormReceivingOfCultivatedAbolone-commentsTransport"
              :label="$$t('commentsTransport')"
              v-model="localReceivingOfCultivatedAbolone.commentsTransport"
            />
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="6">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.internalVerificationCompletedForm25"
              :label="$$t('internalVerificationCompletedForm25')"
            />
          </v-col>
          <v-col cols="3">
            <ColouredValueBool
              :value="localReceivingOfCultivatedAbolone.internalVerificationCompletedForm25 !== undefined"
              text="Required to complete"
            />
          </v-col>
          <v-col
            v-if="!localReceivingOfCultivatedAbolone.internalVerificationCompletedForm25"
            cols="12"
          >
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-internalVerificationCompletedForm25Reason"
              :label="$$t('internalVerificationCompletedForm25Reason')"
              v-model="localReceivingOfCultivatedAbolone.internalVerificationCompletedForm25Reason"
              hint="Reason for internal verification not completed?"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-internalVerificationOfScale"
              :label="$$t('internalVerificationOfScale')"
              v-model="localReceivingOfCultivatedAbolone.internalVerificationOfScale"
              type="number"
              hint="Total mass applied (kg)"
              @change="calculateDeviation"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormReceivingOfCultivatedAbolone-reading"
              :label="$$t('reading')"
              v-model="localReceivingOfCultivatedAbolone.reading"
              type="number"
              @change="calculateDeviation"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              disabled
              data-cy="FormReceivingOfCultivatedAbolone-deviation"
              :label="$$t('deviation')"
              v-model="localReceivingOfCultivatedAbolone.deviation"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.cratesReturned"
              :label="$$t('cratesReturned')"
            />
          </v-col>
          <v-col cols="4">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.cratesCleaned"
              :label="$$t('cratesCleaned')"
            />
          </v-col>
          <v-col cols="4">
            <BoolField
              v-model="localReceivingOfCultivatedAbolone.purgingBagsContained"
              :label="$$t('purgingBagsContained')"
            />
            <ColouredValueBool
              :value="localReceivingOfCultivatedAbolone.purgingBagsContained !== undefined"
              text="Required to complete"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="text-h5">
              Animals suitable for production
            </div>
          </v-col>
          <v-col cols="12">
            <v-text-field
              filled
              label="Size range"
              disabled
              v-model="localReceivingOfCultivatedAbolone.sizeRange"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample1" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample2" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample3" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample4" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample5" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample6" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample7" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample8" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample9" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample10" type="number">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Sample weight" v-model.number="localReceivingOfCultivatedAbolone.sample11" type="number">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div :class="{ dimmed: localReceivingOfCultivatedAbolone.status }">
              <SignVerification role="Process Controller" title="Completed By"
                v-model="localReceivingOfCultivatedAbolone.requestedBySignature" />
              <v-btn block color="success" @click="handover('Ready to be verified')">Handover</v-btn>
            </div>
            <hr class="mb-5 mt-5" />
            <div :class="{ dimmed: localReceivingOfCultivatedAbolone.status !== 'Ready to be verified' }">
              <SignVerification role="Production Manager" title="Verified By"
                v-model="localReceivingOfCultivatedAbolone.verifiedBySignature" />
              <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
            </div>
            <hr class="mb-5 mt-5" />
            <div :class="{ dimmed: localReceivingOfCultivatedAbolone.status !== 'Ready for NRCS' }">
              <SignVerification role="Nrcs" title="NRCS Inspector"
                v-model="localReceivingOfCultivatedAbolone.ncrsSignature"/>
              <v-row>
                <v-col cols="12" class="mb-10">
                  <v-btn block color="success" @click="handover('Completed')">Completed</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              filled
              data-cy="FormReceivingOfCultivatedAbolone-commentsTransport"
              label="Processing Instructions (Sales)"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormReceivingOfCultivatedAbolone-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormReceivingOfCultivatedAbolone-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import BoolField from './BoolField.vue';
import DateField from './DateField.vue';
import ColouredValueBool from './ColouredValueBool.vue';
import SignVerification from './SignVerification.vue';

export default {
  name: 'FormReceivingOfCultivatedAbolone',
  module: 'ReceivingOfCultivatedAbolone',
  mixins: [loading],
  components: {
    BoolField,
    ColouredValueBool,
    DateField,
    SignVerification,
  },
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    ReceivingOfCultivatedAbolone: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localReceivingOfCultivatedAbolone
      */
      localReceivingOfCultivatedAbolone: {},
    };
  },
  computed: {
    isActive() {
      return this.localDeliveryNote.state === 'Receiving';
    },
    /** Vuex states
     */
    ...mapState('farms', ['farms']),
  },
  watch: {
    ReceivingOfCultivatedAbolone() {
      this.localReceivingOfCultivatedAbolone = this.ReceivingOfCultivatedAbolone;
    },
  },
  created() {
    this.localReceivingOfCultivatedAbolone = this.ReceivingOfCultivatedAbolone;
    this.localReceivingOfCultivatedAbolone.dateReceived = this.formatDate(new Date());
  },
  async mounted() {
    const stockItem = await this.LOAD_stockItem(this.$route.query.stockItemId);
    console.debug(stockItem);
    this.localReceivingOfCultivatedAbolone.sizeRange = `${stockItem.sizeMin} - ${stockItem.sizeMax}`;
    console.debug(stockItem.deliveryNote.farmId);
    this.localReceivingOfCultivatedAbolone.farm = stockItem.deliveryNote.farmId;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_stockItem']),
    /** Handover form trigger
     * @event save
     * @type {object}
     */
    handover(status) {
      this.localReceivingOfCultivatedAbolone.status = status;
      if (status === 'Ready to be verified') {
        this.$emit('process', this.localReceivingOfCultivatedAbolone);
      } else {
        this.$emit('save', this.localReceivingOfCultivatedAbolone);
      }
      this.isSaving = true;
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localReceivingOfCultivatedAbolone);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
    calculateDeviation() {
      const scale = this.localReceivingOfCultivatedAbolone.internalVerificationOfScale;
      const { reading } = this.localReceivingOfCultivatedAbolone;
      if (scale && reading) {
        const deviation = reading - scale;
        this.localReceivingOfCultivatedAbolone.deviation = deviation.toFixed(3);
        this.$forceUpdate();
      }
    },
    damagedCutsChanged() {
      console.debug(this.localReceivingOfCultivatedAbolone.damangedCuts);
      if (!this.localReceivingOfCultivatedAbolone.damangedCuts) {
        this.localReceivingOfCultivatedAbolone.damangedCutsWeight = 0;
        this.localReceivingOfCultivatedAbolone.damangedCutsNumber = 0;
      }
    },
    damagedLesionChanged() {
      if (!this.localReceivingOfCultivatedAbolone.damagedLesion) {
        this.localReceivingOfCultivatedAbolone.damagedLesionWeight = 0;
        this.localReceivingOfCultivatedAbolone.damagedLesionNumber = 0;
      }
    },
    visibleParasitesChanged() {
      if (!this.localReceivingOfCultivatedAbolone.visibleParasites) {
        this.localReceivingOfCultivatedAbolone.visibleParasitesWeight = 0;
        this.localReceivingOfCultivatedAbolone.visibleParasitesNumber = 0;
      }
    },
    deadLameAnimalsChanged() {
      if (!this.localReceivingOfCultivatedAbolone.deadLameAnimals) {
        this.localReceivingOfCultivatedAbolone.mortalitiesCount = 0;
        this.localReceivingOfCultivatedAbolone.mortalitiesWeight = 0;
      }
    },
  },
};
</script>

<docs>
# FormReceivingOfCultivatedAbolone example

'''js
<FormReceivingOfCultivatedAbolone :ReceivingOfCultivatedAbolone="ReceivingOfCultivatedAbolone" />
'''
</docs>
